import { useRef } from "react";

export const useSetEffect = (
  effect: () => void,
  deps: React.DependencyList
) => {
  const refPrevDeps = useRef<React.DependencyList | null>(null);
  const isDepsChanged =
    !refPrevDeps.current ||
    deps.some((dep, i) => dep !== refPrevDeps.current![i]);
  if (isDepsChanged) {
    refPrevDeps.current = deps;
    effect();
  }
};
